import React from "react";

import "../Styles/Search.css";

export default function Search(props) {
    return (
        <div className="Search">
            <input type="text" placeholder="Rechercher une recette" value={props.searchTerm} onChange={(event) => {props.setSearchTerm(event.target.value)}}/>
        </div>
    );
}